const HERD_CONTEXT_ROUTES = [
  {
    match: (pathname) => pathname === '/',
    pageLabel: 'پیشخوان مدیریتی',
    fields: ['site', 'unit', 'baharband', 'date'],
    description: 'سایت، واحد، باهاربند و تاریخ مرجع روی شاخص‌های پیشخوان اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/repro',
    pageLabel: 'مرکز باروری',
    fields: ['baharband', 'date'],
    description: 'باهاربند و تاریخ مرجع روی شاخص‌ها و صف‌های کاری باروری اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/repro/planner',
    pageLabel: 'کارتابل باروری',
    fields: ['site', 'unit', 'baharband', 'date'],
    description: 'سایت، واحد، باهاربند و تاریخ روی صف برنامه‌ریزی باروری اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/health',
    pageLabel: 'مرکز سلامت',
    fields: ['baharband', 'date'],
    description: 'باهاربند و تاریخ مرجع روی خلاصه سلامت و هشدارهای این صفحه اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/health/workbench',
    pageLabel: 'میز سلامت و درمان',
    fields: ['site', 'unit', 'dense'],
    description: 'سایت و واحد روی صف درمان و پیگیری‌ها اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/economic/workbench',
    pageLabel: 'کارگاه اقتصادی',
    fields: ['site', 'unit', 'dense'],
    description: 'سایت و واحد روی تحلیل‌های اقتصادی این صفحه اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/reports/kpi-center',
    pageLabel: 'مرکز شاخص‌ها',
    fields: ['site', 'unit'],
    description: 'سایت و واحد روی محاسبه شاخص‌های این صفحه اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/reports/pregnancy-cycles',
    pageLabel: 'تحلیل چرخه باروری',
    fields: ['site', 'unit'],
    description: 'سایت و واحد روی چرخه‌ها، Risk Set و شاخص‌های ۲۱روزه اعمال می‌شود.',
  },
  {
    match: (pathname) => pathname === '/data-quality',
    pageLabel: 'مرکز کیفیت داده',
    fields: ['site', 'unit'],
    description: 'سایت و واحد دامنه پایش و صف خطاهای کیفیت داده را محدود می‌کند.',
  },
];

export function getHerdContextRouteConfig(pathname = '') {
  return HERD_CONTEXT_ROUTES.find((route) => route.match(pathname)) || null;
}

export function pageSupportsHerdContext(pathname = '') {
  return !!getHerdContextRouteConfig(pathname);
}

export const herdContextSupportedPaths = HERD_CONTEXT_ROUTES.map((route) => route.pageLabel);
